class InsuranceRequest {
  //health insurance
  isforeignerno = false;
  addressManualMode = false;
  foreignerno = "";
  passportno = "";
  birthdate = "";
  period = 1;
  startdate = null;
  enddate = null;
  firstname = "";
  lastname = "";
  fathername = "";
  gender = "male";
  country = "";
  state = "";
  stateAuto = null;
  stateManual = "";
  city = "";
  cityAuto = null;
  cityManual = "";
  mahalle = "";
  mahalleAuto = null;
  mahalleManual = "";
  cadde = "";
  bina = "";
  daire = "";
  address = "";
  agencyid = null;
  secondyearonly = false;
  manualmode = false;

  sponsorforeignerno = "";
  sponsorpassportno = "";
  sponsorfirstname = "";
  sponsorlastname = "";
  sponsorbirthdate = "";
  sponsorgender = "male";
  sponsortaxnumber = "";
  iscorporate = false;

  isratiooverriden = false;
  overriddenratio = 0;
  date = null;

  forceifduplicated = false;
  forceasdebt = false;

  constructor() {
    this.startdate = new Date();
    this.enddate = new Date(
      new Date().setFullYear(new Date().getFullYear() + 1)
    );
    this.birthdate = "0000";
    this.sponsorbirthdate = "0000";
    //this.startdate = "0000";
  }
}
export default InsuranceRequest;
